// Generated by Typewriter / DataModelGenerator.tst
// https://frhagn.github.io/Typewriter/pages/documentation.html

import { EntityBaseDto } from './EntityBaseDto';

// AbilityIntranet.Data.Intranet.QbModels.QbListObjectDto
export class QbListObjectDto extends EntityBaseDto {
    public listId: string = null;
    public timeCreated: Date = new Date(0);
    public timeModified: Date = new Date(0);
    public name: string = null;
    public isActive: boolean = false;
    public isDefault: boolean = false;
}


    



